import React from 'react';
import { WithProviders } from '@atlaskit/editor-common/provider-factory';
import { Mention } from '../ui/Mention';
export var MentionNodeView = function MentionNodeView(props) {
  var providerFactory = props.providerFactory;
  var _props$node$attrs = props.node.attrs,
    id = _props$node$attrs.id,
    text = _props$node$attrs.text,
    accessLevel = _props$node$attrs.accessLevel,
    localId = _props$node$attrs.localId;
  var renderAssistiveTextWithProviders = function renderAssistiveTextWithProviders(providers) {
    var _props$options;
    var _ref = providers,
      mentionProvider = _ref.mentionProvider;
    var profilecardProvider = (_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.profilecardProvider;
    return /*#__PURE__*/React.createElement(Mention, {
      id: id,
      text: text,
      accessLevel: accessLevel,
      mentionProvider: mentionProvider,
      profilecardProvider: profilecardProvider,
      localId: localId
    });
  };
  return /*#__PURE__*/React.createElement(WithProviders, {
    providers: ['mentionProvider', 'profilecardProvider'],
    providerFactory: providerFactory,
    renderNode: renderAssistiveTextWithProviders
  });
};